import { render, staticRenderFns } from "./MyConference.vue?vue&type=template&id=6ed830f3&scoped=true&"
import script from "./MyConference.vue?vue&type=script&lang=js&"
export * from "./MyConference.vue?vue&type=script&lang=js&"
import style0 from "./MyConference.vue?vue&type=style&index=0&id=6ed830f3&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ed830f3",
  null
  
)

export default component.exports